import EDIT_ICON from "../../../../assets/svgs/edit.svg";
import unescapeHtmlTag from "../../../../../core/utils/tools";


const TitleDisplayField = ({ toggleEditModeHandler, title }) => {
  const deviceType = sessionStorage.getItem("deviceType");


  return (
    <div className={"detail-design-history-title"}>
      <div className={"label"}>Title</div>
      <div className={"value"}>{ unescapeHtmlTag(title) }</div>
      {
        deviceType === "mobile" && (
          <button onClick={toggleEditModeHandler}>
            <img src={EDIT_ICON}/>
          </button>
        )
      }
    </div>
  )
}
export default TitleDisplayField;
